module.exports = __webpack_public_path__ + "images/backgrounds/fall/medium.7790ec6b980a7d419783.jpg";